module.exports = {"id":"185010","name":"Michał Pazdan","rating":"76","photo":"./data/images/photos/1/185010.png","club":{"name":"Legia Varsovie","logo":"./data/images/clubs/LegiaVarsovie.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MichałPazdan0.json
// module id = 2995
// module chunks = 0